<script>
import { CampPageTree } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit CampPage',
      addRoute: { name: 'Add CampPage' },
      verboseName: 'Camp page',
      verboseNamePlural: 'Camp pages',
      isPaginated: false,
      isTree: true,
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'title_en', label: 'title (en)' },
        { prop: 'slug_en', label: 'slug (en)' }
      ]
    }
  },
  computed: {
    service() {
      return CampPageTree
    }
  }
}
</script>
